// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__34rvi","rootSuccess":"CompleteLink_rootSuccess__yy_YV","rootFailure":"CompleteLink_rootFailure__1gnBf","isDisabled":"CompleteLink_isDisabled__3VNEc"};